"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isValidQuantity = exports.isCallNeedProcessingWithValidQuantity = exports.getCorrectQuantityAndWeightOfProduct = exports.getDefaultQuantityAndWeight = void 0;

var common_uom_1 = require("@ryerson/common.uom");

var common_enums_1 = require("@ryerson/common.enums");

var Enums_1 = require("../Enums");

var quantityConversionHelpers_1 = require("./quantityConversionHelpers");

var common_conversions_1 = require("@ryerson/common.conversions");

var getDefaultQuantityAndWeight = function getDefaultQuantityAndWeight(product, qtyUom, priceUom) {
  var minimumWeightOfCategory = (0, quantityConversionHelpers_1.defaultProductWeight)(product);
  var updatedWeight = (0, quantityConversionHelpers_1.updatedQuantityBasedOnQuantityUom)(product, common_uom_1.lbs.value, minimumWeightOfCategory, false);
  var objectToConvertWeightToQty = (0, quantityConversionHelpers_1.getConversionUomObject)(updatedWeight, common_enums_1.UOM.LB, priceUom, product);
  var convertedWeightToQty = (0, common_conversions_1.convertQuantityUOM)(objectToConvertWeightToQty, qtyUom);
  return {
    defaultQuantityBasedOnQtyUom: convertedWeightToQty,
    defaultWeight: updatedWeight
  };
};

exports.getDefaultQuantityAndWeight = getDefaultQuantityAndWeight;

var getCorrectQuantityAndWeightOfProduct = function getCorrectQuantityAndWeightOfProduct(product, quantity, quantityUom, priceUom) {
  var updatedQty = quantity;
  var updatedWeight;

  if (quantity === 0) {
    var _ref = (0, exports.getDefaultQuantityAndWeight)(product, quantityUom, priceUom),
        defaultQuantityBasedOnQtyUom = _ref.defaultQuantityBasedOnQtyUom,
        defaultWeight = _ref.defaultWeight;

    updatedQty = Number(defaultQuantityBasedOnQtyUom);
    updatedWeight = defaultWeight;
  } else {
    var conversionObject = (0, quantityConversionHelpers_1.getConversionUomObject)(quantity, quantityUom, priceUom, product);
    /**
     * Don’t round the weight, since we’re going to be
     * recalculating it right after this.
     */

    var totalWeightInPound = (0, common_conversions_1.convertQuantityUOM)(conversionObject, common_uom_1.lbs.value, true);
    var actualWeight = (0, quantityConversionHelpers_1.updatedQuantityBasedOnQuantityUom)(product, common_uom_1.lbs.value, Number(totalWeightInPound), false);
    updatedQty = quantity;
    updatedWeight = actualWeight;
  }

  return {
    updatedQuantity: updatedQty,
    updatedWeight: updatedWeight
  };
};

exports.getCorrectQuantityAndWeightOfProduct = getCorrectQuantityAndWeightOfProduct;

var isCallNeedProcessingWithValidQuantity = function isCallNeedProcessingWithValidQuantity(product, processing, quantity) {
  return product.cutFlag !== Enums_1.DefineCut.CutIsAlwaysRequired || product.cutFlag === Enums_1.DefineCut.CutIsAlwaysRequired && Object.keys(processing).length > 0 && quantity > 0;
};

exports.isCallNeedProcessingWithValidQuantity = isCallNeedProcessingWithValidQuantity;

var isValidQuantity = function isValidQuantity(quantity) {
  var minQantity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var maxQuantity = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 99999;
  return quantity >= Number(minQantity) && quantity <= Number(maxQuantity);
};

exports.isValidQuantity = isValidQuantity;